import { useState } from 'react';
import { Phone } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations/translations';
import LanguageSwitcher from './LanguageSwitcher';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { language } = useLanguage();
  const t = translations[language].nav;

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsOpen(false);
    }
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-200 shadow-sm">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex items-center gap-2 cursor-pointer" onClick={() => scrollToSection('fooldal')}>
            <img 
              src="/hgds-logo.png" 
              alt="HGDS Logo" 
              className="h-12 w-auto object-contain"
            />
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-6">
            <button onClick={() => scrollToSection('fooldal')} className="text-gray-700 hover:text-[#7B2F3D] font-medium transition-colors">
              {t.home}
            </button>
            <button onClick={() => scrollToSection('szolgaltatasok')} className="text-gray-700 hover:text-[#7B2F3D] font-medium transition-colors">
              {t.services}
            </button>
            <button onClick={() => scrollToSection('rolunk')} className="text-gray-700 hover:text-[#7B2F3D] font-medium transition-colors">
              {t.about}
            </button>
            <button onClick={() => scrollToSection('kapcsolat')} className="text-gray-700 hover:text-[#7B2F3D] font-medium transition-colors">
              {t.contact}
            </button>
            
            {/* Language Switcher */}
            <LanguageSwitcher />
            
            <button 
              onClick={() => scrollToSection('idopontfoglalas')}
              className="flex items-center gap-2 px-6 py-2.5 bg-[#7B2F3D] text-white rounded-lg hover:bg-[#6A2835] transition-colors font-semibold"
            >
              <Phone className="w-4 h-4" />
              {t.booking}
            </button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center gap-3">
            <LanguageSwitcher />
            <button 
              className="p-2"
              onClick={() => setIsOpen(!isOpen)}
            >
              <div className="w-6 h-5 flex flex-col justify-between">
                <span className={`w-full h-0.5 bg-gray-900 transition-all ${isOpen ? 'rotate-45 translate-y-2' : ''}`}></span>
                <span className={`w-full h-0.5 bg-gray-900 transition-all ${isOpen ? 'opacity-0' : ''}`}></span>
                <span className={`w-full h-0.5 bg-gray-900 transition-all ${isOpen ? '-rotate-45 -translate-y-2' : ''}`}></span>
              </div>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="md:hidden pb-4 space-y-2">
            <button onClick={() => scrollToSection('fooldal')} className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50">
              {t.home}
            </button>
            <button onClick={() => scrollToSection('szolgaltatasok')} className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50">
              {t.services}
            </button>
            <button onClick={() => scrollToSection('rolunk')} className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50">
              {t.about}
            </button>
            <button onClick={() => scrollToSection('kapcsolat')} className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50">
              {t.contact}
            </button>
            <button onClick={() => scrollToSection('idopontfoglalas')} className="block w-full text-left px-4 py-2 bg-[#7B2F3D] text-white rounded-lg">
              {t.booking}
            </button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;